import { render } from "./Games.vue?vue&type=template&id=39a72dbc"
const script = {}

import "./Games.vue?vue&type=style&index=0&id=39a72dbc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__